export default {
  InternalServerError: 'Có lỗi xảy ra, vui lòng thử lại.',
  BusinessError: 'Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ',
  Unauthorized: 'Phiên làm việc đã kết thúc.',
  InsertSuccess: 'Thêm mới thành công.',
  UpdateSuccess: 'Cập nhật thành công.',
  DeleteSuccess: 'Xóa thành công.',
}
